import { Component } from '@angular/core';
import { ModalController, NavController, ToastController } from 'ionic-angular';
import { Storage } from '@ionic/storage';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

  ITEMS_STORAGE_KEY: string = 'time_items';
  NUM_HOURS_TO_WORK: number = 8;

  loading: boolean = true;
  greeting: string = 'Well hello there!';
  totalHours: string = '0';
  totalMinutes: string = '0';
  hoursLabel: string = 'H';
  minutesLabel: string = 'M';
  fullMinutes: number = 0;
  leaveTime: string = '0:00PM';

  timeItems: any[] = [];

  constructor(
    private modalCtrl: ModalController,
    public navCtrl: NavController,
    private storage: Storage,
    private toastCtrl: ToastController
  ) {


  }

  ionViewDidLoad() {

    this.loading = true;
    this.loadSavedItems().then(itemsString => {
      if (itemsString) {
        this.timeItems = JSON.parse(itemsString);
        this.sumUpTime();
      }

      this.loading = false;

      let self = this;
      var x = setInterval(() => {
        this.sumUpTime();
      }, 3600);

    });

  }

  addNewItem() {

  	let now = new Date();
    let lastIndex = this.timeItems.length - 1;
    let isWork = true;

    if (lastIndex >= 0) {
      isWork = !this.timeItems[lastIndex].work;
      this.timeItems[lastIndex].end =  now.toISOString();
    }

    this.timeItems.push({
      start: now.toISOString(),
      end: 'now',
      name: isWork ? 'Work' : 'Break',
      work: isWork
    });

    this.saveItemsToStorage();

  }


  sumUpTime() {

  	var durationInMinutes = 0;

    for (let item of this.timeItems) {

      if (!item.work) {
        continue;
      }

      let startTime = new Date(item.start);
      let endTime;
      if (!item.end || item.end == 'now' || item.end == '') {
        endTime = new Date();
      } else {
        endTime = new Date(item.end);
      }

      let duration = endTime.getTime() - startTime.getTime();

  		durationInMinutes += Math.floor(duration/1000/60);

  	}

  	var hours = Math.floor(durationInMinutes / 60);
  	var minutes = durationInMinutes % 60;

  	hours = hours < 0 ? 0 : hours;
  	minutes = minutes < 0 ? 0 : minutes;

    if (hours > 22) {
      // New day started automatically
      this.showNewDayToast();
      this.reset();
      return;
    }

  	this.setTimeWorked(hours, minutes);

  	let minutesLeft = (this.NUM_HOURS_TO_WORK * 60) - durationInMinutes;

  	var now = new Date();

  	if (minutesLeft > 0) {
  		let timeToLeave = new Date(now.getTime() + (minutesLeft * 60 * 1000));
  		this.leaveTime = this.formatTime(timeToLeave.toString());
  	} else {
      this.leaveTime = 'anytime';
  	}

  }


  formatTime(dateString: string) {

    if (!dateString || dateString == '') {
      return;
    } else if (dateString == 'now') {
      return 'Now';
    }

    let date = new Date(dateString);
  	var period = date.getHours() < 12 ? 'AM' : 'PM';
  	var hours = date.getHours() % 12;
    if (hours == 0) {
      hours = 12;
    }
  	var minutes = date.getMinutes();
  	let minuteString = minutes < 10 ? '0' + minutes : minutes;

  	return hours + ':' + minuteString + period;

  }


  setTimeWorked(hours, minutes) {

    this.totalHours = hours;
    this.totalMinutes = minutes;

  	if (hours === 0) {
      this.totalHours = null;
      this.hoursLabel = '';
  	} else {
      this.hoursLabel = 'H';
  	}

    this.minutesLabel = 'M';

  }


  editItem(i, item) {

    let editModal = this.modalCtrl.create('EditItemPage', {item: item});

    editModal.onDidDismiss(data => {

      if (!data || data == '') {
        return;
      } else if (data == 'DELETE') {
        let previousIndex = i - 1;
        let nextIndex = i + 1;
        if (previousIndex >= 0 && nextIndex < this.timeItems.length) {
          this.timeItems[previousIndex].end = this.timeItems[nextIndex].start;
        } else if (i + 1 == this.timeItems.length) {
          this.timeItems[previousIndex].end = 'now';
        }
        this.timeItems.splice(i, 1);
      } else {
        this.timeItems[i] = data;
        if (i > 0) {
          this.timeItems[i - 1].end = data.start;
        }
      }
      this.sumUpTime();
      this.saveItemsToStorage();

    });

    editModal.present();

  }


  saveItemsToStorage() {
    let stringifiedItems = JSON.stringify(this.timeItems);
    this.storage.set(this.ITEMS_STORAGE_KEY, stringifiedItems);
  }


  loadSavedItems() {
    return this.storage.get(this.ITEMS_STORAGE_KEY);
  }

  reset() {
    this.storage.clear();
    this.timeItems = [];
    this.totalHours = '';
    this.totalMinutes = '0';
    this.hoursLabel = '';
    this.minutesLabel = 'M';
    this.leaveTime = '0:00PM';
    this.addNewItem();
  }

  private showNewDayToast() {
    let toast = this.toastCtrl.create({
      message: 'A new day was started automatically',
      duration: 3000,
      position: 'top'
    });

    toast.present();

  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts